import Text from '~/components/Text';
import type { NavGroup, Publication } from '~/interfaces/publication';

import CategoriesPopover from './CategoriesPopover';
import LinkPopover from './LinkPopover';
import SingleLink from './SingleLink';

interface Props {
  publication: Publication;
}

const Menu = ({ publication }: Props) => {
  const { content_tags, web_template } = publication;

  return (
    <div className="z-20 flex gap-1">
      {web_template?.nav_groups?.map((group: NavGroup) => {
        const isCategoryGroup = group.is_category_group;

        if (isCategoryGroup)
          return (
            <CategoriesPopover key={group.id} subLinks={content_tags} webTemplate={web_template}>
              <Text as="span" type="title" theme="navs" className="text-xs sm:block">
                {group.title}
              </Text>
            </CategoriesPopover>
          );

        if (group.nav_links.length === 0) return null;

        if (group.nav_links.length === 1) {
          return <SingleLink key={group.id} link={group.nav_links[0]} />;
        }

        return (
          <LinkPopover key={group.id} subLinks={group.nav_links}>
            <Text as="span" type="title" theme="navs" className="text-xs sm:block">
              {group.title}
            </Text>
          </LinkPopover>
        );
      })}
    </div>
  );
};

export default Menu;
